export default __webpack_public_path__ + "static/media/double-moon-1.3d250ce0.jpg";